import { useState, useEffect } from 'react';
import axios from '../utils/axios';

export interface RegionBreakdown {
    region_id: number;
    region_name: string;
    unread_count: number;
}

export interface UnreadCountData {
    total: number;
    breakdown: RegionBreakdown[];
}

/**
 * Hook to fetch the number of unread conversations for a given user.
 * 
 * @param {number} userId - The ID of the user to fetch unread conversations for.
 * @returns {UnreadCountData} The unread count data including total and regional breakdown.
 */
export const useUnreadCount = (userId: number): UnreadCountData => {
    const [unreadData, setUnreadData] = useState<UnreadCountData>({
        total: 0,
        breakdown: []
    });

    const fetchUnreadCount = async () => {
        if (!userId)
        {
          return;
        }
        try {
            const response = await axios.get(`/berryAPI/conversations/unreadCount`);
            setUnreadData(response.data);
        } catch (error) {
            console.error('Error fetching unread count:', error);
        }
    };

    useEffect(() => {
        fetchUnreadCount();
        // Poll for updates every 30 seconds
        const interval = setInterval(fetchUnreadCount, 30000);
        return () => clearInterval(interval);
    }, [userId]);

    useEffect(() => {
        const handleMarkAsRead = () => fetchUnreadCount();
        window.addEventListener('unread-count-update', handleMarkAsRead);
        return () => window.removeEventListener('unread-count-update', handleMarkAsRead);
    }, [userId]);

    return unreadData;
}; 